import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Textarea,
} from '@roger/ui-components';

interface UnattainableReasonDialogProps {
  open: boolean;
  onAccept: (reason: string) => void;
  onCancel: () => void;
}

const UnattainableReasonDialog: React.FC<UnattainableReasonDialogProps> = ({
  open,
  onAccept,
  onCancel,
}) => {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (!open) setReason('');
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={isOpen => !isOpen && onCancel()}>
      <DialogContent className='sm:max-w-[425px]'>
        <DialogHeader>
          <DialogTitle>Mark goal as unattainable?</DialogTitle>
          <DialogDescription>
            This action cannot be undone and will mark all interventions for
            this patient as complete.
          </DialogDescription>
        </DialogHeader>
        <Textarea
          placeholder='Enter reason for marking as unattainable...'
          value={reason}
          onChange={e => setReason(e.target.value)}
          textareaSize='default'
          className='min-h-[80px]'
        />
        <DialogFooter>
          <Button variant='outline' onClick={onCancel}>
            Cancel
          </Button>
          <Button
            onClick={() => onAccept(reason.trim())}
            disabled={!reason.trim()}
          >
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UnattainableReasonDialog;
